import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Device, DeviceStatus, DeviceStatusLabel } from '@oxypeak/commons';

@Component({
  selector: 'oxy-device-status',
  templateUrl: './device-status.component.html',
  styleUrls: ['./device-status.component.scss'],
  imports: [TranslateModule],
})
export class DeviceStatusComponent {
  @Input() device!: Device;
  DeviceStatusLabel = DeviceStatusLabel;
  DeviceStatus = DeviceStatus;
}
